import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { SignAndStampUserConsent } from './signAndStampUserConsent.types';

export const signAndStampUserConsentPullQueryBuilder = (document: SignAndStampUserConsent) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query userSignAndStampConsentData($lastRequested: DateTime!) {
      userSignAndStampConsentData(lastRequested: $lastRequested) {
        pk_UserSignAndStampConsentData
        userConsentData
        isActive
        createdBy
        dateCreated
        dateModified
        modifiedBy
      }
    }
  `);
  return {
    query,
    variables: {
      lastRequested: doc?.dateModified ? doc?.dateModified : doc?.dateCreated,
    },
  };
};
